import {
  BackIcon,
  CalendarIcon,
} from '@twistopayments/design-system/icons/inline'

import type { BlogPostCustom } from '@twisto/api-cms'
import { useBreakpoint } from '@twisto/hooks'
import { getMaskFormattedDate } from '@twisto/utils'

import { AccessibleDiv, StrapiMedia } from '../../atoms'

import * as styles from './post.styles'

type PostProps = BlogPostCustom & {
  listItem?: boolean
}

export const Post = ({
  name,
  date,
  image,
  badge,
  btnName,
  path,
  blog_category: category,
  listItem = false,
}: PostProps) => {
  const isMobile = useBreakpoint('smDown')

  return (
    <AccessibleDiv
      css={listItem ? styles.listItemPost : styles.post}
      role="link"
      onActivate={() => window.open(path, '_self')}
    >
      <StrapiMedia {...image} css={styles.image} />
      <div css={[styles.content, listItem && styles.listContent]}>
        <div css={styles.details}>
          {listItem && (badge || category) && (
            <span css={styles.badge}>{badge || category?.name}</span>
          )}
          <div css={styles.date}>
            {listItem && <CalendarIcon size="24" />}
            <span>
              {getMaskFormattedDate(date || '', 'DD.MM.YYYY')}{' '}
              {!listItem &&
                (badge || category) &&
                `• ${badge || category?.name}`}{' '}
            </span>
          </div>
        </div>
        <p css={styles.postName}>{name}</p>
        {(isMobile || listItem) && btnName && (
          <a css={styles.postLink} href={path}>
            {btnName}
            <BackIcon />
          </a>
        )}
      </div>
    </AccessibleDiv>
  )
}
